import { Component, Prop } from 'vue-property-decorator';
import { BaseComponent } from '@/components/base-component';

@Component
export class CountUpItem extends BaseComponent {
	
	@Prop() description: string;
	@Prop() startVal: number;
	@Prop() endVal: number;
	@Prop() duration: number;
	@Prop() sufix: string;

	number: number = 0;
	
	mounted() {
		this.animateValue();
	}

	animateValue() {
		let startTimestamp:any = null;
		const step = (timestamp:any) => {
			if (!startTimestamp) startTimestamp = timestamp;
			const progress = Math.min((timestamp - startTimestamp) / this.duration, 1);
			this.number = Math.floor(progress * (this.endVal - this.startVal) + this.startVal);
			if (progress < 1) {
				window.requestAnimationFrame(step);
			}
		};
		window.requestAnimationFrame(step);
	}
}

export default CountUpItem;
